<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar></navbar>
        <!--END Navbar-->


        <b-row>
            <b-col cols="12" md="8">
                <b-card title="Timer">
                    <b-form inline>

                        <b-form-checkbox v-model="timer.enableTimer" class="mb-2 mr-sm-2 mb-sm-0">is enable?
                        </b-form-checkbox>


                        <date-picker
                                format="YYYY-MM-DD"
                                placeholder="date"
                                display-format="YYYY-MM-DD"
                                locale="en" v-model="timer.timerDate"></date-picker>

                        <b-input placeholder="title" v-model="timer.timerTitle"></b-input>


                        <b-button @click="storeSetting" variant="primary">{{$t('saveTitle')}}</b-button>
                    </b-form>
                </b-card>
            </b-col>
            <b-col cols="12" md="4">
                <b-card title="General Coupons">
                    <b-link
                            :to="{name:'GeneralCoupons'}"
                            class="btn btn-primary btn-round">General Coupons
                    </b-link>
                </b-card>
            </b-col>
        </b-row>

        <b-card title="Filter" class="my-0">
            <b-form-radio-group
                    id="radio-group-1"
                    v-model="filter.value"
                    :options="filter.items"
                    @change="getUsers"
                    name="radio-options"
            ></b-form-radio-group>
        </b-card>
        <!--END Filter-->


        <b-card v-if="users.length > 0" title="Add Gutscheine">
            <b-row>
                <b-col cols="12" md="3">
                    <b-form-group label="category">
                        <v-select
                                class="bg-white"
                                placeholder="select category"
                                label="title"
                                :reduce="title => title.id"
                                v-model="couponItem.categoryIds"
                                multiple
                                :options="categories"></v-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-group label="is multiple use?">
                        <b-form-checkbox v-model="couponItem.is_numberof_uses"></b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3" v-if="couponItem.is_numberof_uses">
                    <b-form-group label="number use ?">
                        <b-input type="number" v-model="couponItem.numberof_can_use"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-group label="code">
                        <b-input v-model="couponItem.code"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-group label="percent">
                        <b-input v-model="couponItem.amount"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-group label="limit price">
                        <b-input v-model="couponItem.price_limit"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-group label="expiry date from now until">
                        <b-input v-model="couponItem.day"></b-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="3">
                    <b-button @click="storeCoupon" variant="success">{{$t('saveTitle')}}</b-button>
                </b-col>
            </b-row>
        </b-card>
        <!--END Form-->

        <b-card>
            <b-input v-model="search" class="mb-4" placeholder="search"></b-input>
            <div class="table-responsive">
                <b-table :filter="search" :fields="table.fields" :items="users">
                    <template v-slot:cell(select)="row">
                        <b-form-checkbox
                                :id="'ch'+row.item.id"
                                :name="'ch'+row.item.id"
                                v-model="couponItem.userIds"
                                :value="row.item.id"
                        >

                        </b-form-checkbox>
                    </template>


                    <template v-slot:cell(action)="row">
                        <b-link
                                :to="{name:'CouponDetails',params:{'userid':row.item.id}}"
                                class="btn btn-info">{{$t('detailsTitle')}} {{row.id}}
                        </b-link>
                    </template>
                </b-table>


            </div>

            <infinite-loading :identifier="infiniteId" :distance="1" @infinite="getUsers"></infinite-loading>

        </b-card>


    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'
    import 'vue-select/dist/vue-select.css';


    export default {
        name: "Index",
        components: {Navbar},
        data() {
            return {
                page: 1,
                infiniteId: +new Date(),
                search: null,
                timer: {
                    enableTimer: false,
                    timerDate: null,
                    timerTitle: null,
                },
                table: {
                    fields: [
                        {
                            key: 'select',
                            label: 'select'
                        },
                        {
                            key: 'email',
                            label: 'Email'
                        },
                        {
                            key: 'name',
                            label: 'Nutzername'
                        },
                        {
                            key: 'coupons',
                            label: 'Gutscheine'
                        },
                        {
                            key: 'action',
                            label: 'action'
                        },
                    ]
                },
                categories: [],
                users: [],
                filter: {
                    items: [
                        {
                            text: 'Mehr als ein Monat',
                            value: 'notordermonth'
                        },
                        {
                            text: 'Nicht bestellen',
                            value: 'notorder'
                        }
                    ],
                    value: null
                },
                couponItem: {
                    userIds: [],
                    categoryIds: [],
                    amount: 0,
                    is_numberof_uses: false,
                    numberof_can_use: null,
                    code: null,
                    price_limit: 0,
                    day: 7,
                }
            }
        },
        methods: {
            storeCoupon() {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'coupon/store', this.couponItem)
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            Notification.success(response.data.message)
                        } else {
                            Notification.error(response.data.message)
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getCategories() {
                this.$Progress.start();
                Http.get(Http.apiurlV2() + 'coupon/create')
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.categories = response.data.data;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            storeSetting() {
                this.$Progress.start();
                if (this.timer.timerTitle === null || this.timer.timerDate === null) {
                    Notification.error("please check fields");
                    return;
                }
                Http.post(Http.apiurlV2() + 'coupon/update', {
                    items: {
                        is_enable_timer: this.timer.enableTimer,
                        timer_date: this.timer.timerDate,
                        timer_title: this.timer.timerTitle,
                    }
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            // this.getSettingTitle();
                            Notification.success(response.data.message)

                        } else {
                            Notification.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getSetting() {
                Http.get(Http.apiurlV2() + 'coupon/index')
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.timer.enableTimer = response.data.data.enable_timer;
                            this.timer.timerTitle = response.data.data.timer_title;
                            this.timer.timerDate = response.data.data.timer_date;

                            this.getCategories();

                        } else {
                            Notification.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getUsers($state) {
                this.$Progress.start();
                let url;

                if (this.filter.value !== null) {
                    url = Http.apiurlV2() + 'coupon/users/filter/' + this.filter.value + '?page=' + this.page;
                } else {
                    url = Http.apiurlV2() + 'coupon/users/filter' + '?page=' + this.page
                }

                Http.get(url)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.couponItem.userIds = [];
                            if (response.data.data.length > 0) {
                                this.page += 1;
                                this.users.push(...response.data.data);
                                $state.loaded();
                            }else {
                                $state.complete();
                            }
                            this.users.map(item => {
                                this.couponItem.userIds.push(item.id);
                            })

                        } else {
                            Notification.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
        },
        created() {
            this.getUsers();
            this.getSetting();
        }
    }
</script>

<style scoped>

</style>